import Vue from 'vue'
import Vuex from 'vuex'
import streamSettings from './modules/streamSettings' // Import module

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        streamSettings, // Register it
    }
})
